import { CLIENT_TYPES_ID, ClientTypes } from '~/constants/clientTypes.ts';
import { ERROR_CODES } from '~/constants/errorCodes.ts';
import { Link } from '@mui/material';

export const LEGAL_RESIDENT_QUESTIONS = (
  isOwnershipStructureTreeEnabled: boolean,
  isAdditionalInformationAboutTaxResidencyEnabled: boolean,
  isFATCALegalResidentEnabled: boolean
) => [
  ...(!isFATCALegalResidentEnabled
    ? [
        {
          title:
            'Чи є Ваша юридична особа або її засновники, кінцеві бенефіціарні власники (КБВ) податковими резидентами США?',
          name: 'isUSTaxResident',
        },
      ]
    : []),
  ...(!isFATCALegalResidentEnabled
    ? [
        {
          title:
            'Чи є Ваша юридична особа іноземною фінансовою установою відповідно до Закону FATCA?',
          name: 'isForeignFinancialUnderFATCA',
        },
      ]
    : []),
  {
    title:
      'Чи володіє Ваша юридична особа або її власники (кінцеві бенефіціарні власники (КБВ), прямі/опосередковані власники - резиденти України) часткою в іноземній юридичній особі (незалежно від величини частки володіння)?',
    name: 'hasForeignShare',
  },

  ...(!isAdditionalInformationAboutTaxResidencyEnabled
    ? [
        {
          title:
            'Чи є Ваша юридична особа або її засновники, кінцеві бенефіціарні власники (КБВ) резидентами іншої юрисдикції (країни) крім України та США?',
          name: 'isOtherTaxResident',
        },
      ]
    : []),
  ...(!isOwnershipStructureTreeEnabled
    ? [
        {
          title:
            'Чи має Ваша юридична особа у структурі власності інших юридичних осіб, які володіють часткою статутного капіталу?',
          name: 'proxyAccountManagers',
        },
      ]
    : []),
];

export const SOLE_TRADER_QUESTIONS = (isCRSIFopEnabled: boolean, isFATCAFopEnabled: boolean) => [
  {
    title: 'Чи володієте Ви часткою в іноземній юридичній особі?',
    name: 'isUSTaxResident',
  },
  ...(!isFATCAFopEnabled
    ? [
        {
          title:
            'Чи є Ви громадянином США або податковим резидентом США відповідно до законодавства США?',
          name: 'isForeignFinancialUnderFATCA',
        },
      ]
    : []),
  ...(!isCRSIFopEnabled
    ? [
        {
          title:
            'Чи маєте Ви статус податкового резидента іншої юрисдикції (країни) крім України та США?',
          name: 'isOtherTaxResident',
        },
      ]
    : []),
  {
    title:
      'Чи наявні у Вас представники, які діють на підставі довіреності та будуть розпоряджатися рахунком?',
    name: 'proxyAccountManagers',
  },
];

export const contragentTypes = [
  { value: CLIENT_TYPES_ID[ClientTypes.SOLE_TRADER], label: 'Фізична особа–підприємець' },
  { value: CLIENT_TYPES_ID[ClientTypes.LEGAL_RESIDENT], label: 'Юридична особа-резидент' },
  { value: CLIENT_TYPES_ID[ClientTypes.ASSET_MANAGER], label: 'Розпорядник' },
];

export const infoTextTooltipTariffs = {
  851: 'Застосовується виключно для неприбуткових підприємств, установ, організацій, які включені  до Реєстру неприбуткових установ та організацій',
  740: 'До корпоративних клієнтів відносяться: господарські організації (незалежно від організаційно-правової форми) з їх спорідненими підприємствами (дочірніми підприємствами, профспілковими організаціями, засновниками/власниками – юридичними особами тощо), річний обсяг виручки від реалізації товарів та послуг яких становить 1 500 млн. грн. і більше.',
};
export const errorCodes = [
  ERROR_CODES.CLIENT_TYPE_ERROR,
  ERROR_CODES.YOU_SCORE_API_ERROR,
  ERROR_CODES.YOU_SCORE_UPDATE_ERROR,
  ERROR_CODES.YOU_SCORE_UNKNOWN_ERROR,
  ERROR_CODES.STRABIS_API_ERROR,
  ERROR_CODES.STATUS_ERROR,
  ERROR_CODES.DATA_NOT_FOUND_EDR,
  ERROR_CODES.DATA_NOT_FOUND,
  ERROR_CODES.DUPLICATE_APPLICATION,
  ERROR_CODES.APPLICATION_SEARCH_ERROR,
  ERROR_CODES.DOCUMENT_FETCH_FAILED,
];

export const QUESTION_FIELDS = [
  'isUSTaxResident',
  'isForeignFinancialUnderFATCA',
  'isOtherTaxResident',
  'proxyAccountManagers',
  'hasForeignShare',
];

export const getManagerNotFoundMessage = () => (
  <>
    Інформація про керівника компанії відсутня в Єдиному державному реєстрі. Будь ласка, зверніться
    через{' '}
    <a
      href="https://diia.gov.ua/"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'rgb(1, 102, 179)' }}
    >
      Портал Дія
    </a>{' '}
    або до державного реєстратора для внесення цих даних у реєстр. Далі повторіть спробу відкриття
    рахунку.
  </>
);

export const informerIsOtherTaxResident = (
  <>
    У випадку “Так” необхідно заповнити обов'язково розділ “Додаткова інформація про податкове
    резидентство” для формування документу самостійної оцінки CRS-E. Інформація про Загальний
    стандарт звітності CRS та відповідні форми самостійної оцінки, розміщено на офіційному сайті
    Міністерства фінансів України за посиланнями:{' '}
    <Link
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        color: 'lightblue',
        textDecorationColor: 'lightblue',
      }}
      href="https://mof.gov.ua/uk/crs-578"
      target="_blank"
      rel="noopener noreferrer"
    >
      Міністерство Фінансів України.
    </Link>
    Неподання або подання неповної/недостовірної інформації призводить до порушення ст.1181
    Податкового кодексу України
  </>
);

export const informerIsControllingPersonTaxResidentOtherJurisdiction = (
  <>
    У випадку “Так” необхідно заповнити обов'язково розділ “Додаткова інформація про податкове
    резидентство” для формування документу самостійної оцінки CRS-E та CRS-CP. Інформація про
    Загальний стандарт звітності CRS та відповідні форми самостійної оцінки, розміщено на офіційному
    сайті Міністерства фінансів України за посиланнями:{' '}
    <Link
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        color: 'lightblue',
        textDecorationColor: 'lightblue',
      }}
      href="https://mof.gov.ua/uk/crs-578"
      target="_blank"
      rel="noopener noreferrer"
    >
      Міністерство Фінансів України.
    </Link>
    Неподання або подання неповної/недостовірної інформації призводить до порушення ст.1181
    Податкового кодексу України
  </>
);

export const informerFATCA =
  "У випадку “Так” необхідно заповнити обов'язково розділ “Додаткова інформація (FATCA)” для формування самостійної оцінки FATCA.";
